import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntLocationStopIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props}>
      <path d="M10 0H0L3 2L6 8H16L13 2H11L10 0Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 2L10 0H8L9 2H7L6 0H4L5 2H3L2 0H0L7 15L8 16L9 15L6 7.99999L8 8L7 6H9L11 10H14L16 7.99999L15 6H13L12 4H14L13 2H11ZM10 4L9 2H11L12 4H10ZM11 6H9L8 4H10L11 6ZM6 4L7 6H5L4 4H6ZM6 4H8L7 2H5L6 4ZM11 6L12 8H14L13 6H11Z"
      />
    </SntIcon>
  );
};

export default SntLocationStopIcon;
